// @ts-strict-ignore
import { request, type RequestProps } from '@node-space/rest-api'

type RequestApiProps<TData = Record<string, unknown>> = Omit<RequestProps<TData>, 'headers'> & {
  headers?: Record<string, string>
}

export const customHeaders: RequestApiProps['headers'] = {
  'x-requester': process.env.BASE_URL,
  'x-tag': 'merchant-portal',
}

export const requestApi = <TData = Record<string, unknown>>({
  url,
  method,
  data,
  params,
  admin,
  authenticated,
  impersonate,
  debug,
  access_token,
  secret,
  baseUrl,
  fullResponse,
  bff,
  timeout,
  config,
  headers = customHeaders,
}: RequestApiProps<TData>) => {
  return request<TData>({
    url,
    method,
    data,
    params,
    headers: headers as RequestProps['headers'],
    admin,
    authenticated,
    impersonate,
    debug,
    access_token,
    secret,
    baseUrl,
    fullResponse,
    bff,
    timeout,
    config,
  })
}
